var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 50,
    viewBox: "0 0 99 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 36.25V23.75H61V36.25H51ZM38.5 26.25V13.75H48.5V26.25H38.5ZM46 23.75V16.25H41V23.75H46ZM38.5 36.25V28.75H48.5V36.25H38.5ZM41 33.75H46V31.25H41V33.75ZM53.5 33.75H58.5V26.25H53.5V33.75ZM51 13.75H61V21.25H51V13.75ZM53.5 16.25V18.75H58.5V16.25H53.5Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreGames);
export default __webpack_public_path__ + "static/media/more-games.38522617fa5fa05e4632b957a4229043.svg";
export { ForwardRef as ReactComponent };